import {
  Card,
  Checkbox,
  Field,
  RichTextarea,
  type RichTextContent,
} from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { nanoid } from 'nanoid';
import { FC, useRef } from 'react';

export interface IProps {
  className?: string;
  term: RichTextContent;
  checked: boolean;
  onChange?: (value: boolean) => void;
}

const AcceptTermCard: FC<IProps> = (props) => {
  const { className, term, checked, onChange } = props;

  const { current: uId } = useRef(nanoid());

  return (
    <Card
      as="label"
      className={clstx('cursor-pointer', className)}
      htmlFor={`accept-terms-${uId}`}
    >
      <Card.Body className="flex gap-4">
        <Field.Legacy id={`accept-terms-${uId}`} name={`accept-terms-${uId}`}>
          <Checkbox
            checked={checked}
            onChange={(e) => {
              onChange?.(e.currentTarget.checked);
            }}
          />
        </Field.Legacy>

        <RichTextarea readOnly value={term} />
      </Card.Body>
    </Card>
  );
};

export default AcceptTermCard;
